import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const AlertOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function AlertOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13 8h-2v5.5h2V8ZM12 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M8.71 3.89A3.765 3.765 0 0 1 12 2c1.28 0 2.56.63 3.29 1.89l7.22 12.38c1.48 2.54-.35 5.73-3.29 5.73H4.78c-2.94 0-4.77-3.19-3.29-5.73L8.71 3.89Zm4.85 1.01C13.09 4.09 12.31 4 12 4h-.01c-.31 0-1.09.09-1.56.9L3.21 17.28c-.47.81-.16 1.54 0 1.81s.62.91 1.57.91h14.43c.95 0 1.41-.64 1.57-.91.16-.27.48-.99 0-1.81L13.56 4.9Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default AlertOutlined;